// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;The Lord is my strength and my shield;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my heart has trusted in him and I am helped;<br> </p> </div></div>";
// Exports
module.exports = code;